export default "__VITE_ASSET__Ddaqq8N1__"